module.exports = __webpack_public_path__ + "static/buzzyBoothLogo.ae25d063.png";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/img/vendors/buzzyBoothLogo.png
// module id = 658
// module chunks = 172845445241205